<template>
    <div class="register-wrapper">
        <div class="top d-flex a-center j-sb">
            <div class="code d-flex a-center">
                <img src="@/assets/img/login/account.png" alt="" class="crr" v-if="showCode" @click="change">
                <img src="@/assets/img/login/scan.png" alt="" class="crr" v-else @click="change">
                <p class="col-main f-size-14" v-if="showCode">账号密码注册</p>
                <p class="col-main f-size-14" v-else>扫码注册更便捷</p>
            </div>
            <img src="@/assets/img/login/close.png" alt="" class="close crr" @click="closeLoginTip">
        </div>
        <div class="code-box" v-loading="codeLoading" v-if="showCode">
            <div class="qrcode">
                <template>
                    <img src="@/assets/img/register.png" alt="">
                    <!-- <div class="wrap d-flex a-center j-center" v-if="[-1, 2].includes(codeType)">
                        <i class="el-icon-refresh-right crr" @click="getQrCode"></i>
                    </div> -->
                </template>
                <!-- <div class="code-yes d-flex a-center j-center">
                    <div style="text-align: center;">
                        <img src="@/assets/img/yikan.png" alt="">
                        <p>扫描成功</p>
                    </div>
                </div> -->
            </div>
            <div class="tips">请使用微信扫描二维码注册AI食育师</div>
        </div>
        <div class="login-box" v-if="!showCode">
            <div class="tabs d-flex">
                <p class="active">账号密码注册</p>
            </div>
            <el-form :model="loginForm" ref="loginFormRef" class="login-form" :rules="loginRules">
                <el-form-item prop="role">
                    <el-radio-group v-model="loginForm.role">
                        <el-radio label="TEACHER">教师</el-radio>
                        <el-radio label="PARENT">家长</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="mobile">
                    <el-input v-model="loginForm.mobile" placeholder="请输入您的手机号码" autocomplete="off" clearable />
                </el-form-item>
                <el-form-item prop="name">
                    <el-input v-model="loginForm.name" placeholder="请输入您的姓名" autocomplete="off" clearable />
                </el-form-item>
                <el-form-item prop="gender">
                    <el-select placeholder="请选择您的性别" v-model="loginForm.gender" style="width: 100%;">
                        <el-option value="MALE" label="男"></el-option>
                        <el-option value="FEMALE" label="女"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="address" label-suffix="el-icon-female">
                    <Cascader v-model="loginForm.address" style="width: 100%;" :options="addressList"
                        :props="{ checkStrictly: true }" @change="handleChange"></Cascader>
                </el-form-item>
                <el-form-item prop="school">
                    <el-select v-model="loginForm.school" placeholder="请选择学校" style="width: 100%;">
                        <el-option v-for="item in schoolList" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model="loginForm.password" type="password" placeholder="请输入8-12位密码，虚含大写、小写和数字"
                        autocomplete="off" show-password clearable />
                </el-form-item>
                <el-form-item>
                    <div class="d-flex a-center j-sb">
                        <el-input placeholder="请输入验证码" v-model="loginForm.captcha" clearable></el-input>
                        <img class="iiimg" :src="imgCode" @click="getImgCode" alt="">
                    </div>
                </el-form-item>
                <div class="agree d-flex a-center" style="margin-bottom: 24px;">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <p class="color-9 f-size-14" style="margin-left: 10px;">同意<span class="crr" @click="toUrl(1)">《服务条款》</span>和<span class="crr"
                            @click="toUrl(2)">《隐私政策》</span></p>
                </div>
                <el-form-item>
                    <el-button type="primary" class="login-btn" :loading="registerLoading" @click="registerAction">注册</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { registerLoading } from "echarts/lib/echarts";
import { Cascader } from "element-ui";
// 自定义手机号验证
const validatePhone = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入手机号'));
    } else {
        const phoneReg = /^1[3-9]\d{9}$/;
        if (!phoneReg.test(value)) {
            callback(new Error('请输入正确的手机号码'));
        } else {
            callback();
        }
    }
};
// 自定义密码验证函数
const validatePassword = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入密码'));
    } else {
        // 同时验证大写、小写和数字的正则表达式
        const passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
        if (!passwordReg.test(value)) {
            callback(new Error('密码必须包含大写字母、小写字母和数字'));
        } else {
            callback();
        }
    }
};
export default {
    name: 'Register',
    components: {
        Cascader
    },
    data() {
        return {
            showCode: false,
            loginForm: {
                password: '',
                role: 'TEACHER',
                gender: 'MALE',
                address: [],
                school: []
            },
            loading: false,
            imgCode: '',
            authCodeId: '',
            checked: false,
            addressList: [],
            schoolList: [],
            registerLoading: false,
            loginRules: {
                mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validatePhone, trigger: 'blur' }],
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                address: [{ required: true, message: '请选择区县', trigger: 'change' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { validator: validatePassword, trigger: 'blur' }
                ],
                captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.fetchAddressTree();
        this.getImgCode();
    },
    methods: {
        change() {
            this.showCode = !this.showCode
        },
        closeLoginTip() {
            this.$store.commit('setRegisterTip', false)
        },
        toUrl(index) {
            if (index == 1) {
                window.open('https://open.xaou.sn.cn/viewdetail/236367549160226816', '_blank')
            } else if (index == 2) {
                window.open('https://open.xaou.sn.cn/viewdetail/236367585815298048', '_blank')
            }
        },
        getImgCode() {
            this.loading = true
            this.$api.login.captcha().then((res) => {
                this.loading = false
                if (res.code === 'SUCCESS') {
                    this.authCodeId = res.data.id
                    this.imgCode = this.$utils.baseURL + res.data.captcha_image
                }
            })
        },
        fetchAddressTree() {
            const handle = (item) => {
                return {
                    value: item.id,
                    label: item.name,
                    children: item.child_list && item.child_list.length > 0
                        ? item.child_list.map(handle)
                        : undefined
                };
            }
            this.$api.login.getAddressTree().then(res => {
                if (res.data.code !== 'SUCCESS') return;
                const list = handle(res.data.data);
                this.addressList = [list];

            })
        },
        fetchSchoolList(params) {
            this.$api.login.getSchoolList(params).then(res => {
                console.log('adasdasd', res);
                if (res.code !== 'SUCCESS') return;
                this.schoolList = res.data.data_list || [];
            })
        },
        handleChange(value) {
            if (!value || value.length <= 0) return;
            this.fetchSchoolList({
                zone_id: value[value.length - 1],
                page_request_data: {
                    page_no: 1,
                    page_size: 1000
                },
            })
            console.log(value);
        },
        async registerAction() {
            if (this.checked == false) {
                this.$message.warning('请同意服务条款和隐私政策后再注册');
                return;
            }
            await this.$refs.loginFormRef.validate()
            this.registerLoading = true;
            this.$api.login.registerUser({
                ...this.loginForm,
                user_extend: {
                    school_id: this.loginForm.school,
                    zone_id: this.loginForm.address[this.loginForm.address.length - 1]
                },
                captcha_session_id: this.authCodeId
            }).then(res => {
                if (res.code !== 'SUCCESS') {
                    this.$message.warning(res.message)
                    this.getImgCode()
                    return;
                } else {
                   this.closeLoginTip();
                   this.$message.success('注册成功，请登录');
                   this.$store.commit('setLoginTip',true)
                }
            }).finally(() => {
                this.registerLoading = false;
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.register-wrapper {
    width: 400px;
    background-color: #fff;

    .code-box {
        height: 450px;

        .qrcode {
            width: 400px;
            height: 400px;
            margin: auto;
            position: relative;

            img {
                width: 400px;
                height: 400px;
            }

            .wrap {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                z-index: 1;
                background: rgba($color: #FFFFFF, $alpha: 0.98);

                i {
                    color: #6E6E6E;
                    font-size: 40px;
                }
            }

            .code-yes {
                width: 100%;
                height: 100%;

                img {
                    width: 60px;
                    height: 60px;
                }

                p {
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    margin-top: 24px;
                    letter-spacing: 2px;
                }
            }
        }

        .tips {
            margin-top: 10px;
            text-align: center;
        }
    }

    .top {
        padding: 10px 0;

        .code {
            img {
                width: 30px;
                height: 30px;
            }

            p {
                background: url('@/assets/img/login/kuang.png') no-repeat;
                background-size: 100% 100%;
                padding: 4px 8px 4px 20px;
            }
        }

        .close {
            width: 20px;
            height: 20px;
        }
    }

    .login-box {
        margin-top: 20px;
    }

    .login-btn {
        width: 100%;
        height: 40px;
        border-radius: 5px;
        font-size: 16px;
    }

    .iiimg {
        width: 148px;
        height: 40px;
    }

    .tabs{
        margin-bottom: 20px;
        p{
            font-size: 26px;
            font-weight: bold;
            position: relative;
            flex: 1;
            text-align: center;
            cursor: pointer;
        }
        .active{
            color: #03B355;
        }
        .active::after{
            content: '';
            width: 60px;
            height: 3px;
            background-color: #03B355;
            position: absolute;
            left: 50%;
            bottom: -12px;
            margin-left: -30px;
        }
    }
}
</style>